const ADS_ID = process.env.REACT_APP_ADS_ID;

export const trackConversion = (conversionLabel, conversionValue = null) => {
  if (window.gtag) {
    const conversionData = {
      send_to: `${ADS_ID}/${conversionLabel}`
    };

    if (conversionValue) {
      conversionData.value = conversionValue;
    }

    window.gtag("event", "conversion", conversionData);
  }
};

export const createOnboardingID = () => {
  // Generate a unique ID for onboarding tracking
  return `onboarding_${Math.random().toString(36).substr(2, 9)}`;
};

export const saveOnboardingID = (id) => {
  sessionStorage.setItem("onboardingID", id);
};

export const getOnboardingID = () => {
  return sessionStorage.getItem("onboardingID");
};

export const removeOnboardingID = () => {
  sessionStorage.removeItem("onboardingID");
};

export const trackOnboardingStep = (step) => {
  const onboardingID = getOnboardingID();
  if (onboardingID) {
    trackConversion(step, onboardingID);
  } else {
    const newID = createOnboardingID();
    saveOnboardingID(newID);
    trackConversion(step, newID);
  }
};
